import { useGlobalStore } from "@/stores/global";
import { FEATURE_FLAG, FeatureFlag } from "@/types/feature-flag";

/**
 * Reads a single backend-loaded feature flag off the current organization.
 * Absent / unloaded flags read as disabled, so gated UI stays hidden until the
 * backend explicitly turns the flag on for the org (or the environment).
 */
export const useFeatureFlag = (flag: FeatureFlag): boolean =>
  useGlobalStore((state) => state.organization?.featureFlags?.[flag] ?? false);

/** Kill switch for Stripe-billed surfaces; Fonepay/NPR orgs are unaffected. */
export const useStripePaymentsEnabled = (): boolean =>
  useFeatureFlag(FEATURE_FLAG.STRIPE_PAYMENTS);
